<div *ngIf="!rows.length" class="color-gray-dark">Выберите районы</div>
<div *ngFor="let row of rows; trackBy: trackDistrict" class="district-coefficient">
  <div class="district-coefficient__fields">
    <label [for]="'district-coefficient-' + row.district.d_id" class="district-coefficient__name">
      {{ row.district.district_name }}
      <span *ngIf="row.district.city" class="text-italic color-gray-dark ml-8">{{ row.district.city.ct_name }}</span>
    </label>
    <select
      class="input-text district-coefficient__value"
      [id]="'district-coefficient-' + row.district.d_id"
      [formControl]="row.control"
      [attr.aria-busy]="row.loading"
      [attr.aria-describedby]="'district-coefficient-status-' + row.district.d_id"
    >
      <option *ngIf="hasCustomCoefficient(row)" [value]="row.savedCoefficient" disabled>
        {{ row.savedCoefficient.replace('.', ',') }} (текущий)
      </option>
      <option *ngFor="let option of coefficientOptions" [value]="option.value">{{ option.label }}</option>
    </select>
  </div>
  <div [id]="'district-coefficient-status-' + row.district.d_id" aria-live="polite">
    <span *ngIf="row.loading" class="color-gray-dark">Загрузка коэффициента…</span>
    <span *ngIf="!row.loading && !row.loadError && !row.saveError && !row.record" class="color-gray-dark">
      Коэффициент не задан. Значение сохранится вместе с участком.
    </span>
    <div *ngIf="row.loadError" class="color-red-dark">
      {{ row.loadError }}
      <button
        type="button"
        class="button ml-8"
        [id]="'district-coefficient-retry-' + row.district.d_id"
        (click)="loadCoefficient(row)"
        [disabled]="saving"
      >Повторить</button>
    </div>
    <div *ngIf="row.saveError" class="color-red-dark">{{ row.saveError }}</div>
  </div>
</div>
<div *ngIf="rows.length" class="color-gray-dark mt-4">От 0,50 до 2,00 с шагом 0,10</div>
